<template>
  <div class="card-list">
    <ShadowBoxTitleDescription
      class="shadow-box"
      :title="cardListTitle"
      :isLeftText="true"
      opacity="_60"
      :addPaddingLeft="true"
    >
      <img
        v-if="shipping_type == '1'"
        src="/img/shipping_icon.png"
        class="icon"
      >
      <img
        v-if="shipping_type == '2'"
        src="/img/redeem_icon.png"
        class="icon"
      >
      <div class="card-list-container">
        <!-- <PrevButton
          class="btn prev"
          @handlePrevBtnClick="handlePrevBtnClick"
        /> -->
        <div class="scroll-container">
          <template v-for="(cardItem, index) in cardList">
            <div class="card-container" :key="index">
              <div class="image-area">
                <img
                  class="card"
                  :src="cardItem.image" :alt="cardItem.card_name"
                >
                <div class="chkblock">
                  <div class="no-shipping">
                    <img
                      v-if="shipping_type == '2'"
                      src="/img/no_shipping.png"
                    >
                    <span v-if="shipping_type == '2'" class="point">
                      {{cardItem.buy_point | comma}}<span class="unit">Gem</span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-info">
                <div class="name">
                  <span class="text">{{cardItem.name}}</span>
                </div>
                <div class="model-number">
                  <span class="text">{{cardItem.model_number}}</span>
                </div>
                <div v-if="cardItem.num > 1" class="num">
                  <span class="text">{{cardItem.num}}{{t('枚セット')}}</span>
                </div>
                <div class="rarity">
                  <span class="text">{{cardItem.rarity_label}}</span>
                </div>
                <!-- <div v-if="isPoint" class="point_area">
                  <span v-if="cardItem.action_type == '2'" class="only_ship">Only Shipping</span>
                  <span v-if="cardItem.action_type != '2'" class="point"  :class="{coin: isCoin}">{{cardItem.buy_point | comma}}</span> -->
                  <!--ここで枚数を掛けるとカードを引いた後が倍がけになるため掛けてはいけない-->
                <!-- </div> -->
              </div>
            </div>
          </template>
        </div>
      </div>
    </ShadowBoxTitleDescription>
      <!-- <NextButton
        class="btn next"
        @handleNextBtnClick="handleNextBtnClick"
      /> -->
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import t from '@/plugins/i18n';

export default {
  name: 'CardList',
  mixins: [t],

  props: {
    cardListTitle: {
      type: String,
    },
    cardList: {
      type: Array,
      default: () => [],
    },
    isCoin: {
      type: Boolean,
      default: false,
    },
    isPoint: {
      type: Boolean,
      default: true,
    },
    shipping_type: {
      type: String,
      default: '',
    },
  },

  components: {
    ShadowBoxTitleDescription,
    // PrevButton,
    // NextButton,
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  methods: {
    // handlePrevBtnClick() {
    //   this.$emit('handlePrevBtnClick');
    // },
    // handleNextBtnClick() {
    //   this.$emit('handleNextBtnClick');
    // },
  },
};
</script>

<style lang="scss" scoped>
$shadowBtnHeight: 77px;

.card-list{
  width: 100%;
  .shadow-box {
    position: relative;
    .icon {
      position: absolute;
      left: 0;
      top: 0;
      width: 40px;
    }
  }
  .card-list-container{
    position: relative;
    width: 100%;
    min-height: 154px;
    margin-top: 10px;
    white-space: nowrap;
    .btn{
      position: absolute;
      height: $shadowBtnHeight;
      top: calc(50% - #{$shadowBtnHeight}/2);
      &.prev{
        left: 10px;
      }
      &.next{
        right: 10px;
      }
      @media screen and  (min-width: $tabletWidth) {
        display: none;
      }
    }
    .scroll-container{
      display: flex;
      // overflow: hidden;
      // overflow-x: auto;
      margin-top: 10px;
      @media screen and  (min-width: $tabletWidth) {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        overflow: visible;
        margin-top: -10px;
        .card{
          margin-top: 10px;
        }
      }
      justify-content: center;
      flex-wrap: wrap;
      // &::before{
      //   content: '';
      //   min-width: 20px;
      //   flex: 1;
      //   height: 10px;
      // }
      // &::after{
      //   content: '';
      //   min-width: 20px;
      //   flex: 1;
      //   height: 10px;
      // }
      .card-container{
        display: flex;
        flex-direction: column;
        // width: 100px;
        width: 135px;
        // min-width: 100px;
        // min-width: 135px;
        // margin-left: 5px;
        margin-left: 29px;
        // & + .card-container{
        //   margin-left: 20px;
        // }
        // &:first-of-type{
        //   margin: 0 auto;
        // }
        margin-top: 10px;
        .image-area {
          position: relative;
        }
        .card{
          width: 100%;
          // height: 146px;
        }
        .card-info{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          flex: 1;
          width: 100%;
          .name, .model-number{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            padding: 2px 2px;
            .text{
              display: inline-block;
              font-family: $notoSans;
              font-size: 12px;
              color: $white;
              line-height: 1.25;
              white-space: pre-wrap;
            }
          }
          .num {
            .text {
              color: $white;
            }
          }
          .rarity {
            padding: 0px 10px 4px 10px;
            border-radius: 5px;
            border: solid 1px $white;
            background-color: $white;
            span {
              white-space: pre-wrap;
              display: inline;
              font-size: 12px;
              color: $mainColor;
            }
          }
          .point_area {
            font-size: 12px;
            color: $white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .point {
              font-size: 20px;
              font-weight: 700;
              margin-left: 5px;
              position: relative;
              &:after {
                content: "Gem";
              }
            }
            .coin {
              font-size: 20px;
              font-weight: 700;
              margin-left: 5px;
              position: relative;
              &:after {
                content: "C";
              }
            }
            .only_ship {
              font-size: 16px;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
}
.chkblock {
  position: absolute;
  // left: calc(50% - 15px);
  bottom: 30px;
  .check-box{
    width: 30px;
    height: 30px;
    margin: 0 auto 0;
    border-radius: 100px;
    background-color: $lightRed;
    border-color: $lightRed;
    color: $lightGray;
    &.active {
      background-color: $mainColor;
      border-color: $mainColor;
      color: $white;
    }
  }
  img {
    width: 100%;
  }
  .no-shipping {
    position: relative;
    .point {
      font-weight: bold;
      position: absolute;
      top: 44%;
      left: 62%;
      transform: translate(-50%, -50%);
      font-size: 14px;
      .unit {
        font-size: 12px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .chkblock {
    .no-shipping {
      .point {
        font-size: 10px;
        .unit {
          font-size: 8px;
        }
      }
    }
  }
  .card-list{
    .card-list-container{
      .scroll-container{
        .card-container{
          width: 110px;
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
